import { useModal } from '@hooks/useModal';
import React, { useMemo } from 'react';
import ConfirmDialog from '@commons/confirm-dialog';
import { useCustomMutation } from "@hooks/useCustomMutation";
import ReservationForm from '@modules/reservations/form';
import { saveReservation } from '@/services/reservations';

export const useReservationModal = () => {
  const { open, handleChange } = useModal();
  const [id, setId] = React.useState<number | undefined>();
  const handleChangeModal = React.useCallback((idTemp?: number) => {
    setId(idTemp);
    handleChange();
  }, [handleChange]);

  const { mutateAsync, isPending } = useCustomMutation(['reservations', 'create'], saveReservation, {
    message: 'Create success!',
    callbackSuccess: () => {
      handleChangeModal()
    },
  });
  const modal = useMemo(
    () => (
      <ConfirmDialog
        maxWidth="sm"
        disabledActions
        open={open}
        loading={isPending}
        onClose={handleChangeModal}
        content={<ReservationForm onSave={mutateAsync} />}
        title="Nueva Reservacion"
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [open, handleChangeModal, mutateAsync]
  );
  return {
    modal,
    actionModal: handleChangeModal,
  };
};
